import { Hint } from '@insify/funnel-components';
import clsx from 'clsx';
import { useTranslation } from 'react-i18next';

import { ActionGroup } from '../ActionGroup';
import { CertificateButton } from '../CertificateButton';
import { CertificateStatusBlock } from '../CertificateStatusBlock';
import { DocumentDownloadButtons } from '../DocumentDownloadButtons';

import * as styles from './CoverageCard.module.css';

import type { Bundle, Coverage } from '../../types/Policy';
import type { InsifyProps } from '@insify/ui';

export const CoverageCard: React.FC<InsifyProps & { coverage: Coverage; policy: Bundle }> = ({
  className,
  coverage,
  policy,
}) => {
  const { t } = useTranslation('policy');

  // RiskCarrier is missing if the policy was not patched yet.
  const waitingCertificate = policy.type === 'company' && coverage.riskCarrier === undefined;

  // Checking for the activity title is a workaround as we cannot check for activity code and adding it
  // to the backend would not work for existing policies as the i2go event replay mechanism is broken.
  const isFrPncRealEstateAgent: boolean =
    policy.type === 'company' && !!policy.activities.find(({ title }) => title === "Agent commercial de l'immobilier");

  return (
    <ActionGroup.Container className={styles.container}>
      <div key={coverage.wordingsURL} className={clsx(styles.coverageCard, className)}>
        <div className={styles.coverageCardHeader}>
          <h4 className={styles.coverageTitle}>{t(coverage.title)}</h4>
          <div className={styles.coverageStartDate}>{coverage.startDate}</div>
          <CertificateStatusBlock
            coverage={coverage}
            waitingCertificate={waitingCertificate}
            className={styles.statusBlock}
          />
        </div>

        {/* <ActionGroup.Item>
          <ActionGroup.Title icon={<IconicDocumentShield />}>{t('common.view_policy')}</ActionGroup.Title>
        </ActionGroup.Item> */}
        {
          /* Currently only supporting FRANCE */
          coverage.title === 'coverage_professionalLiability' && <CertificateButton coverage={coverage} />
        }
        <DocumentDownloadButtons coverage={coverage} policyType={policy.type} />
        {
          /* Hint for FR PNC / Real estate agents */
          isFrPncRealEstateAgent && (
            <Hint className={styles.hint}>
              En tant qu&apos;agent commercial immobilier, vous pourriez vouloir ajouter des informations sur votre
              mandataire immobilier à votre attestation d&apos;assurance. Nous serons ravis de vous envoyer une
              attestation à personnaliser avec ces détails.&#32;
              <strong>
                Envoyez-nous simplement un e-mail à <a href='mailto:support@insify.fr'>support@insify.fr</a>
              </strong>
              &#32; avec les informations à ajouter et nous vous enverrons une attestation à personnaliser.
            </Hint>
          )
        }
      </div>
    </ActionGroup.Container>
  );
};
